import { ColumnsType } from "antd/es/table";
import { IExportData } from "@/pages/export-list/types";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { dateFormatter, FormatType } from "project-config/utils/date-formatter";

const t = getTranslateNsT("center");

export const columns: ColumnsType<IExportData> = [
  {
    title: t("consumption_time_selector"),
    dataIndex: "billTime",
    render: (v) => dateFormatter(v, FormatType.YMD),
  },
  {
    title: t("user_operate_record_user_name"),
    dataIndex: "userName",
  },
  {
    title: t("bill_account_type"),
    dataIndex: "accountType",
    render: (row) => t(`consumption_account_type_${row}`),
  },
  {
    title: t("user_binfo_perfect_item_company_name"),
    dataIndex: "company",
  },
  {
    title: t("consumption_label_fee_type"),
    dataIndex: "feeType",
    render: (v) => t(`consumption_fee_type_${v}`),
  },
  {
    title: t("consumption_label_node_type"),
    dataIndex: "nodeType",
    render: (v) => ["CPU", "GPU"][v] || "",
  },
  {
    title: t("consumption_currency"),
    dataIndex: "currency",
    render: (v) => (v === 1 ? "RMB" : "USD"),
  },
  {
    title: t("consumption_pay_amount"),
    dataIndex: "amountPayable",
  },
  {
    title: t("consumption_desktop_amount"),
    dataIndex: "feeAmount",
  },
];
